module.exports = __webpack_public_path__ + "static/img/value2.5736fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/value2.png
// module id = flxL
// module chunks = 0